import { EnumOption } from "./enum-option";

export const VisaType = {
    B1B2: 0,
    E1: 1,
    E2: 2,
    E3: 3,
    F1: 4,
    F2: 5,
    H1B: 6,
    H1B1: 7,
    H4: 8,
    K1: 9,
    K2: 10,
    L1: 11,
    L2: 12,
    O1: 13,
    TD: 14,
    TN: 15,
    VisaWaiverProgramESTA: 16,
    J1 : 17,
    J2 : 18,
};

export const VisaTypeList: EnumOption[] = [
    { value: VisaType.B1B2, label: 'B-1/B-2' },
    { value: VisaType.E1, label: 'E-1' },
    { value: VisaType.E2, label: 'E-2' },
    { value: VisaType.E3, label: 'E-3' },
    { value: VisaType.F1, label: 'F-1' },
    { value: VisaType.F2, label: 'F-2' },
    { value: VisaType.H1B, label: 'H-1B' },
    { value: VisaType.H1B1, label: 'H-1B1' },
    { value: VisaType.H4, label: 'H-4' },
    { value: VisaType.K1, label: 'K-1' },
    { value: VisaType.K2, label: 'K-2' },
    { value: VisaType.L1, label: 'L-1' },
    { value: VisaType.L2, label: 'L-2' },
    { value: VisaType.O1, label: 'O-1' },
    { value: VisaType.TD, label: 'TD' },
    { value: VisaType.TN, label: 'TN' },
    { value: VisaType.VisaWaiverProgramESTA, label: 'Visa Waiver Program (ESTA)' },
    { value: VisaType.J1, label: 'J-1' },
    { value: VisaType.J2, label: 'J-2' },
];